// "use server";

import fetcher from "@/lib/fetcher";
import { actionClient } from "@/lib/safe-action";
import { objToCamelCase } from "@/lib/utils";

export const fetchHomeBanners = actionClient.action(async () => {
  const response = await fetcher("/api/common-ws/api/v1/bannerList");

  if (!response.ok) {
    throw new ResourseError("Failed to fetch Homepage Banners");
  }

  // Return the data from the response
  const data = await response.json();
  if (data.status === 200) return objToCamelCase(data.response);

  return null;
});

export const fetchTestimonials = actionClient.action(async () => {
  const response = await fetcher(
    "/api/common-ws/api/v1/web/home/testimonials/list"
  );

  if (!response.ok) {
    throw new ResourseError("Failed to fetch Homepage Banners");
  }

  // Return the data from the response
  const data = await response.json();
  if (data.success) return objToCamelCase(data.data);

  return null;
});
